<template>
  <div :class="$style.modal">
    <component
      v-if="image && typeof image === 'object'"
      :is="image"
      :class="[
        $style.modal__icon,
        leftAlign && $style['modal__icon--left-align'],
      ]"
    />
    <img
      v-else-if="image && typeof image === 'string'"
      :src="image"
      :alt="imageAlt"
      :class="[
        $style.modal__icon,
        leftAlign && $style['modal__icon--left-align'],
      ]"
    />
    <h2
      :class="[
        $style.modal__title,
        leftAlign && $style['modal__title--left-align'],
      ]"
    >
      {{ title }}
    </h2>
    <div
      :class="[
        $style.modal__details,
        leftAlign && $style['modal__details--left-align'],
      ]"
    >
      <slot name="body"></slot>
    </div>
    <div v-if="buttonPrimary || buttonSecondary" :class="$style.modal__nav">
      <DSButton
        v-if="buttonSecondary"
        :class="$style.modal__nav__button"
        class="p-button-outlined p-button-secondary"
        :label="buttonSecondary.label"
        @click="$emit('secondary-click')"
      />
      <DSButton
        v-if="buttonPrimary"
        :class="$style.modal__nav__button"
        :label="buttonPrimary.label"
        @click="$emit('primary-click')"
      />
    </div>
    <div v-if="$slots.footer" :style="{ marginTop: '30px' }">
      <slot name="footer"></slot>
    </div>
    <div
      v-if="showDefaultHelp"
      :class="[
        $style.modal__help,
        leftAlign && $style['modal__help--left-align'],
      ]"
    >
      Need help? Email us at
      <a :href="ContactSupportMethods.email.href">{{
        ContactSupportMethods.email.display
      }}</a>
      or {{ ContactSupportMethods.phone.display }}, Monday to Friday,
      {{ ContactSupportMethods.supportHours.display }}.
    </div>
  </div>
</template>

<script>
import DSButton from 'primevue/button';
import { ContactSupportMethods } from '@/data/contact-support';

export default {
  components: {
    DSButton,
  },
  data() {
    return {
      ContactSupportMethods,
    };
  },
  props: {
    title: { type: String },
    image: { type: [Object, String] },
    imageAlt: { type: String, default: 'Modal icon' },
    buttonPrimary: { type: Object },
    buttonSecondary: { type: Object },
    leftAlign: { type: Boolean, default: false },
    showDefaultHelp: { type: Boolean, default: false },
  },
};
</script>

<style>
body .p-dialog .p-dialog-header {
  padding-bottom: 0;
}

.p-dialog:has([data-payment-added-modal]) .p-dialog-header {
  min-height: 0 !important;
}

.p-dialog:has([data-payment-added-modal]) .p-dialog-content:last-of-type {
  margin-top: 0;
}
</style>

<style lang="less" module>
.modal {
  max-width: 545px;
}

body h2.modal__title {
  font-family: @regular-font;
  color: #000;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
}

body h2.modal__title--left-align {
  text-align: left;
}

.modal__icon {
  width: 100%;
  max-width: 130px;
  margin: 0 auto 30px;
  display: block;
}

.modal__icon--left-align {
  width: 54px;
  height: 54px;
  margin-left: 0;
  left: 3px;
  top: 3px;
  margin-bottom: 18px;
}

body .modal__details p,
.modal__help {
  font-family: @regular-font;
  color: black;
}

body .modal__details p {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-bottom: 30px;
}

.modal__help {
  margin-top: 25px;
  text-align: center;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: -0.1px;
  line-height: 20px;
}

body .modal__details--left-align p,
.modal__help--left-align {
  text-align: left;
}

.modal__help a {
  color: #215cb6;
  text-decoration: none;
}

.modal__nav {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
}

.modal__nav__button {
  width: 100%;
  display: flex;
  height: auto;
}

@media (max-width: 650px) {
  .modal__nav {
    flex-direction: column;
    gap: 8px;
  }
}
</style>
